import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

/**
 * Empty / loading / "nothing here yet" placeholder. Renders inside a
 * table row colspan or a Stack — caller decides.
 *
 *   <EmptyState>No discount codes yet.</EmptyState>
 */
export default function EmptyState({ children, action, sx }) {
  return (
    <Stack alignItems='flex-start' spacing='8px' sx={{ p: '4px', ...sx }}>
      <Typography variant='body2' color='text.secondary'>
        {children}
      </Typography>
      {action && <Box>{action}</Box>}
    </Stack>
  );
}
